var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNewVoteIconExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.162 3H16V5.984H19.031V8.015H16V10H19V12H16V14H19V16H16V18H19V20H16V23H25.162C25.623 23 26 22.609 26 22.13V3.87C26 3.391 25.623 3 25.162 3ZM24 20H20V18H24V20ZM24 16H20V14H24V16ZM24 12H20V10H24V12ZM24 8H20V6H24V8Z",
    fill: "#4ED4A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.889V23.112L15 26V0L0 2.889ZM9.488 18.08L7.743 14.781C7.677 14.658 7.609 14.432 7.538 14.103H7.511C7.478 14.258 7.4 14.494 7.277 14.81L5.526 18.08H2.807L6.035 13.016L3.082 7.951H5.858L7.306 10.988C7.419 11.228 7.52 11.513 7.61 11.842H7.638C7.695 11.644 7.801 11.35 7.956 10.959L9.566 7.95H12.108L9.071 12.972L12.193 18.079L9.488 18.08Z",
    fill: "#4ED4A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewVoteIconExcel);
export default __webpack_public_path__ + "static/media/AddNewVoteIconExcel.dd6d3c04b90a987f6d4774ae4f1c0d4c.svg";
export { ForwardRef as ReactComponent };